import { CardSkeleton, SectionHeadingSkeleton, TableSkeleton } from "@/components/Skeleton";

export default function EventOverviewSkeleton() {
  return (
    <div className="flex flex-col" data-testid="event-overview-skeleton">
      <div className="grid grid-cols-1 md:grid-cols-12 sm:gap-12">
        <div className="col-span-1 md:col-span-4 mt-12" data-testid="event-overview-skeleton-sidebar">
          {[1, 2, 3].map((i) => (
            <CardSkeleton key={i} width={100} className="mb-6" rows={4} />
          ))}
        </div>
        <div className="col-span-1 md:col-span-8 sm:mt-7" data-testid="event-overview-skeleton-main">
          <SectionHeadingSkeleton />
          <CardSkeleton width={100} rows={4} />
        </div>
      </div>

      <TableSkeleton columns={7} rows={3} />

      <SectionHeadingSkeleton />
      <CardSkeleton width={100} rows={3} />
    </div>
  );
}
